import type { BuildState } from '../types';
import { monstersPack } from './index';

const STAT_KEYS = ['ferocity', 'agility', 'arcane', 'resilience', 'stealth'] as const;

export function monsterComputeStats(b: BuildState): Record<string, number> {
  const out: Record<string, number> = Object.fromEntries(STAT_KEYS.map(k => [k, 0]));

  // Species baseline
  const hullId = b.hull;
  const species = typeof hullId === 'string' ? monstersPack.hulls[hullId] : null;
  if (species?.baseStats) {
    for (const k of STAT_KEYS) out[k] += species.baseStats[k] ?? 0;
  }

  // Attached parts
  for (const slot of ['cranium', 'back', 'tail'] as const) {
    const id = b[slot];
    if (typeof id !== 'string') continue;
    const part = monstersPack.parts[id];
    if (!part?.weights) continue;
    for (const k of STAT_KEYS) out[k] += part.weights[k] ?? 0;
  }

  // Clamp
  for (const k of STAT_KEYS) out[k] = Math.max(0, Math.min(100, out[k]));

  return out;
}
